// Define application route paths in a single object for easy reference and maintenance
const ROUTES = {
  // Public Routes
  login: '/login',
  beneficiarySignIn: '/sign-in',
  autoLogin: '/autoLogin',
  error: '/error',

  // Twin creation routes
  twinCreation_Outlet: '/twincreation',
  twinIntro: 'intro',
  twinCameraCheck: 'cameracheck',
  twinChooseFlow: 'chooseflow',
  twinPermission: 'permission',
  twinLikenessGuide: 'likenessguide',
  twinLikenessConsent: 'likenessconsent',
  twinLikeness: 'likeness',
  twinInterview: 'interview',
  // twinPersonality: 'personality',
  twinUpload: 'upload',
  twinAddBeneficiaries: 'addbeneficiaries',
  twinEnd: 'end',

  // audioOnly flow routes
  audioFlow_Outlet: '/audioflow',
  audioFlow_guide: 'guide',
  audioFlowLikeness: 'likeness',

  // App Routes
  welcome: '/welcome',
  home_Outlet: '/home',
  homeLikeness: 'likeness',
  homeRecordVoice: 'recordvoice',
  homePersonality: 'personality',
  // homeInterview: 'interview',
  homeAddBeneficiaries: 'addbeneficiaries',
  HomeUpload: 'upload',

  // Viewer Routes
  viewer: '/viewer',
  startFreeTrial: '/startfreetrail',
};

// Export the ROUTES object for use in other modules
export default ROUTES;
